import React, { useContext } from 'react'
import { css, useTheme } from '@emotion/react'
import { ReactComponent as AccountIconWhite } from 'images/account-icon-white.svg'
import classNames from 'classnames'
import Link from 'components/link'
import AppContext from 'context/app'

const linkStyle = theme => css({
    color: 'white',
    '&:hover': { textDecorationColor: 'white' },

    [theme.queries.lg]: {
        fontFamily: theme.fonts.roboto,
        fontSize: 22,
        fontWeight: 500,
        lineHeight: '140%',
        color: 'black',
            
        display: 'flex', // take full width
        paddingBlock: 20,
        paddingInline: 16,
        
        '&:hover': {
            background: theme.colors.primary,
            textDecorationColor: 'transparent',
        }
    }
})

export default function Menu(){
    const theme = useTheme()
    const { clientWidth } = useContext(AppContext)
    
    return(
        <ul
            className='d-flex'
            style={{
                paddingLeft: 0,
                listStyleType: 'none',
            }}
            css={{
                gap: 40,
                alignItems: 'center',
                [theme.queries.lg]: {
                    gap: 0,
                    alignItems: 'start',
                    flexDirection: 'column',
                    '& li': { width: '100%' },
                },
            }}
        >
            <li>
                <Link to='/brands' css={linkStyle}>
                    Our Brands
                </Link>
            </li>
            <li>
                <Link
                    href='https://inmusicbrands.pinpointhq.com'
                    css={[linkStyle, {
                        [theme.queries.lg]: {
                            '& path': {
                                fill: 'black'
                            }
                        }
                    }]}
                >
                    Careers
                </Link>
            </li>
            <li>
                <Link to='/about' css={linkStyle}>
                    About Us
                </Link>
            </li>
            <li>
                <Link to='/press' css={linkStyle}>
                    Press
                </Link>
            </li>
            <li>
                <Link
                    href='https://profile.inmusicbrands.com'
                    css={{[theme.queries.lg]:{ marginInline: 16, marginBlock: 20 }}}
                    style={{ padding: 12, fontSize: 16, fontWeight: 500 }}
                    className={classNames(
                        'btn',
                        { 'white': clientWidth > theme.breakpoints.lg },
                        { 'black': clientWidth <= theme.breakpoints.lg },
                    )}
                >
                    <AccountIconWhite />
                    inMusic Profile
                </Link>
            </li>
        </ul>
    )
}
